import { Error, User } from 'lib/types/global';
import { camelCase } from 'lib/utils/objectSerializer';

import { isServer } from 'lib/common/constants';
import formatUser from '../users/format';
import {
  API_LOGIN_REQUEST,
  API_LOGIN_SUCCESS,
  API_READ_SESSION_SUCCESS,
  API_LOGIN_FAILURE,
  API_LOGOUT_SUCCESS,
} from './actionTypes';
import { SessionAction } from './actions';

export interface SessionState {
  loading: boolean;
  user?: User;
  error?: Error;
  receivedAt?: number;
}

export const initialState: SessionState = {
  loading: false,
};

export default function sessionReducer(
  state: SessionState = initialState,
  action: SessionAction,
) {
  switch (action.type) {
    case API_LOGIN_REQUEST:
      return { ...state, loading: true, error: undefined };

    case API_LOGIN_SUCCESS:
    case API_READ_SESSION_SUCCESS:
      return {
        ...initialState,
        loading: false,
        user: formatUser(camelCase(action.payload)),
        receivedAt: !isServer ? performance.now() : 0,
      };

    case API_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        user: undefined,
        error: { ...action.payload, status: action.status },
      };

    case API_LOGOUT_SUCCESS: {
      return initialState;
    }

    default:
      return state;
  }
}
